module.exports = __webpack_public_path__ + "static/media/aiops_architecture_diagram.db344755.png";